'use client';

import { forwardRef, useContext } from 'react';

import { css, cx } from '@/styled-system/css';

import { PaginationRootContext } from './context/pagination-root.context';
import { paginationListStyles } from './styles/pagination-list.styles';
import type { PaginationListPropsInterface } from './types/pagination-list.types';

/**
 * The Pagination's `ul` element
 * @since 10.0.0
 */
export const PaginationList = forwardRef<HTMLUListElement, PaginationListPropsInterface>(
  (props: PaginationListPropsInterface, forwardedRef) => {
    const { className, css: cssProp, ...rest } = props;
    const { showNumberButtons } = useContext(PaginationRootContext);

    const styles = css(cssProp, paginationListStyles.raw({ ...showNumberButtons }));

    return (
      <ul
        className={cx('c11n', 'c11n_pagination__list', styles, className)}
        data-c11n-component="Pagination.List"
        data-c11n-version={__C11N_VERSION__}
        ref={forwardedRef}
        {...rest}
      />
    );
  },
);

PaginationList.displayName = 'Pagination.List';
